import guid from '../utils/guid';

import { BiEvent } from './types';

// define bi events relations
const transactionsMap = {
  [BiEvent.EPISODE_PLAY_REQUESTED]: [
    BiEvent.EPISODE_PLAY_STARTED,
    BiEvent.EPISODE_PLAY_ERROR,
  ],
  [BiEvent.NAVIGATION_REQUESTED]: [BiEvent.NAVIGATION_COMPLETED],
  [BiEvent.FEED_LOAD_REQUESTED]: [BiEvent.FEED_LOAD_COMPLETED],
  [BiEvent.FEED_LOAD_MORE_REQUESTED]: [BiEvent.FEED_LOAD_MORE_COMPETED],
};

function getStartEvent(event): BiEvent {
  return Object.keys(transactionsMap).find((_event: BiEvent) =>
    transactionsMap[_event].includes(event),
  ) as BiEvent;
}

interface ITransaction {
  id: any;
  startEvent: BiEvent;
  startTime: Date;
  endTime?: Date;
  duration?: number;
}

class BITransaction {
  private readonly _activeTransactions: { [event: string]: ITransaction };

  constructor() {
    this._activeTransactions = {};
  }

  start(startEvent: BiEvent) {
    const transaction = {
      id: guid(),
      startEvent,
      startTime: new Date(),
    };

    this._activeTransactions[startEvent] = transaction;

    return transaction;
  }

  end(eventOrTransaction: BiEvent | ITransaction): ITransaction {
    const transaction =
      typeof eventOrTransaction === 'object'
        ? eventOrTransaction
        : this._activeTransactions[getStartEvent(eventOrTransaction)];

    if (!transaction) {
      return;
    }

    const endTime = new Date();
    // https://github.com/Microsoft/TypeScript/issues/5710
    const duration = +endTime - +transaction.startTime;

    return {
      ...transaction,
      endTime,
      duration,
    };
  }
}

export default BITransaction;
